"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialAPIState = exports.apiCallWithRedux = void 0;
var _api = require("./api");
// import store from './../redux/store';

const initialAPIState = exports.initialAPIState = {
  isLoading: false,
  data: null,
  error: null
};
const returnReducer = reducerName => {
  return (state = initialAPIState, action) => {
    switch (action.type) {
      case `${reducerName}/IS_LOADING`:
        return {
          ...state,
          isLoading: true
        };
      case `${reducerName}/API_SUCCESS`:
        return {
          ...state,
          isLoading: false,
          data: action.payload
        };
      case `${reducerName}/API_FAIL`:
        return {
          ...state,
          isLoading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
};
const apiCallWithRedux = async ({
  store,
  reducerName,
  ...props
}) => {
  const asyncReducerName = Object.keys(store.asyncReducers);
  if (!asyncReducerName.includes(reducerName)) {
    store.injectReducer(reducerName, returnReducer(reducerName));
    store.persistor.persist();
  }

  // Loader True
  store.dispatch({
    type: `${reducerName}/IS_LOADING`
  });

  // API CAlling
  const apiData = await (0, _api.apiCall)({
    ...props
  });

  // Manage API response
  if (apiData.success) {
    store.dispatch({
      type: `${reducerName}/API_SUCCESS`,
      payload: apiData.response
    });
  } else {
    store.dispatch({
      type: `${reducerName}/API_FAIL`,
      payload: apiData.error
    });
  }
  return apiData;
};
exports.apiCallWithRedux = apiCallWithRedux;